"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// (DA)零售店与SR关系管理模块
var _default = exports.default = {
  getList: function getList(data, cancelToken) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/sfeRetailorStoreRefSr/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getDetails: function getDetails(id) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/sfeRetailorStoreRefSr/query/' + id,
      method: 'post'
    });
  },
  import: function _import(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/sfeRetailorStoreRefSr/upload',
      method: 'post',
      data: data
    });
  },
  export: function _export(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/sfeRetailorStoreRefSr/export',
      method: 'post',
      data: data,
      responseType: 'blob'
    });
  },
  downloadResultExcel: function downloadResultExcel(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/sfeRetailorStoreRefSr/export_upload_detail',
      method: 'post',
      data: data,
      responseType: 'blob'
    });
  }
};